import type { GetTweetFeed200TweetsItem } from './getTweetFeed200TweetsItem';

export type GetTweetFeed200 = {
  currentPage?: number;
  hasNext?: boolean;
  totalElements?: number;
  totalPages?: number;
  tweets?: GetTweetFeed200TweetsItem[];
};
